import { render, staticRenderFns } from "./ProviderInfo.vue?vue&type=template&id=a80409b2&scoped=true&"
import script from "./ProviderInfo.vue?vue&type=script&lang=ts&"
export * from "./ProviderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderInfo.vue?vue&type=style&index=0&id=a80409b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80409b2",
  null
  
)

export default component.exports